module.exports = __webpack_public_path__ + "static/media/npc.3258fb9f.png";